import React, { useEffect, useState } from "react";
import { dashboard_popup_teacher_profile_details_icon } from "../../assets/images/images";

import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { useSelector } from "react-redux";

import { toast } from "react-toastify";
import { isRequired, validateSubjectNames } from "../../utils/validator";
import { PlusIcon } from "../FileRepo/Icons";
import { getSubjects, getInterests } from "../../pages/home/components/dashboard/student/profile.api.js";
import LoaderComponent from "../LoaderComponent/LoaderComponent";

function EditSubject(props) {
  const globalState = useSelector((state) => state.globalState);

  const [formErrors, setFormErrors] = useState({
    subject_names: "",
  });
  const [formState, setFormState] = useState({
    subject_names: "",
  });
    const [subsinput, setsubsinput] = useState("");
  

  const onSubjectSubmit = (e) => {
    e.preventDefault();
    const subject_names = formState.subject_names;
      // Validate the subject names (using both required and format checks)
  const validationErrors = validateSubjectNames(subject_names);

  if (validationErrors) {
    // If there are validation errors, show them in the toast
    toast.dismiss();
    toast.error(validationErrors.join(", "), {
      position: "top-center",
    });
    return; // Exit early if validation fails
  }
    if (subject_names.length > 0) {
      let errors = {};
      errors.subject_names = isRequired(subject_names);

      setFormErrors(errors); // Always update the error state regardless of whether there are errors
      // Check if there's an error message in any of the errors
      const hasErrors = Object.values(errors).some((error) => error !== "");

      if (hasErrors) {
        // Do not call props.setModalClose(); as there are errors
      } else {
        props.onSubmit(subject_names); // Call the onSubmit prop function
        props.setModalClose(); // Close the modal only if there are no errors
      }
    }
  };

  const [subjects, setSubjects] = useState(props?.subjectlist || []);
  const [inputappends, setInputappends] = useState([]);

  const [Addtosubjects, setAddtosubjects] = useState([]);
  // const [isSuggestionsLoading, setIsSuggestionsLoading] = useState(false);

  const appendValue = (newValue) => {
    setInputappends([...inputappends, newValue]);
  };

  const removeValue = (valueToRemove) => {
    setInputappends(inputappends.filter((item) => item !== valueToRemove));
  };
  useEffect(() => {
    // Use existing data from global state instead of making duplicate API call
    if (globalState?.datalist?.subjects) {
      setAddtosubjects(
        Object.values(globalState?.datalist?.top_ten_subjects ?? {})
      );
    }
  }, [globalState?.datalist]);

useEffect(() => {
    // "Subject" model → subjects list, otherwise → interests list
    const fetchData =
      props.modalStatus === "Subject" ? getSubjects : getInterests;
    // setIsSuggestionsLoading(true);
    fetchData()
      .then((data) => {
        const names = (data?.data || [])
          .filter((item) => item.name && item.name.trim() !== "")
          .map((item) => item.name);
        setAddtosubjects(names);
      })
      .catch((error) => {})
      // .finally(() => setIsSuggestionsLoading(false));
  }, [props.modalStatus])
const addSuggestion = (suggestion) => {
  const normalizedSuggestion = suggestion.trim().toLowerCase();

  const exists = subjects.some(
    (subject) => subject.trim().toLowerCase() === normalizedSuggestion,
  );

  if (exists) {
    toast.dismiss();
    toast.error(`Interest already added.`, {
      position: "top-center",
    });
    return;
  }

  appendValue(suggestion);

  const tempsubj = globalState?.datalist?.subjects;
  let etsval = "";

  for (const id in tempsubj) {
    if (tempsubj[id].toLowerCase() === normalizedSuggestion) {
      etsval = id;
    }
  }

  appendValue(etsval);

  setSubjects([...subjects, suggestion]);

  setFormState((prev) => ({
    ...prev,
    subject_names: [...subjects, suggestion].filter(
      (subject) => subject !== "",
    ),
  }));

  let errors = {};

  if ([...subjects, suggestion].length < 1) {
    errors.subject_names = "Please enter alteast one interest.";
  }

  setFormErrors(errors);
};
  const removeSubject = (subjectToRemove) => {
    const tempsubj = globalState?.datalist?.subjects;
    let rmval = "";
    for (const id in tempsubj) {
      if (tempsubj[id] === subjectToRemove) {
        rmval = id;
      }
    }
    removeValue(rmval);
    const updatedSubjects = subjects.filter(
      (subject) => subject !== subjectToRemove
    );
    setSubjects(updatedSubjects);
    setFormState((prev) => ({
      ...prev,
      subject_names: updatedSubjects.filter((subject) => subject !== ""),
      // .join(",")
    }));
    let errors = {};
    if (updatedSubjects.length < 1) {
      errors.subject_names = "Please enter alteast one interest.";
    }
    setFormErrors(errors);
  };

  const handleInputKeyPress = async (event) => {
    const innerInputValue = event.target.value.trim().toLowerCase(); // Convert input value to lowercase

    if (event.key === "Enter" && innerInputValue !== "") {
      event.preventDefault();

      // Check if the lowercase input value already exists in the array (also converted to lowercase)
      const exists = subjects.some(
        (subject) => subject.trim().toLowerCase() === innerInputValue
      );

      if (!exists) {
        event.target.value = "";
        setsubsinput("");
        addSuggestion(innerInputValue.trim());
      } else {
        toast.dismiss();
        toast.error(`Interest already added.`, {
          position: "top-center",
        });
      }
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    let error = "";
    if (name === "subject_names") {
      error = isRequired(value);
    }
    setFormErrors({
      ...formErrors,
      [name]: error,
    });
    if (name === "subject_names") {
      setFormState((prev) => ({
        ...prev,
        subject_names: subjects.filter((subject) => subject !== ""),
      }));
    } else {
      setFormState((prev) => ({ ...prev, [name]: value }));
    }

    setsubsinput(value);
  };
  const handleModalClose = () => {
    // Only close the modal if there are no errors
    if (!formErrors.subject_names) {
      props.setModalClose();
    }
  };
  const isTeacher = globalState.role === "Teacher";

  const handleAddsubs = async (event) => {
    event.preventDefault();

    const innerInputValue = subsinput.trim().toLowerCase();

    if (innerInputValue === "") {
      return;
    }

    const exists = subjects.some(
      (subject) => subject.trim().toLowerCase() === innerInputValue
    );

    if (!exists) {
      setsubsinput("");
      addSuggestion(innerInputValue.trim());
    } else {
      toast.dismiss();
      toast.error(`Interest already added.`, {
        position: "top-center",
      });
    }
  };
  return (
    <Modal open={props.modalStatus} onClose={handleModalClose} center>
      <div className="dashboard-popup-teacher-profile-details-title">
        <div className="dashboard-popup-teacher-profile-details-image">
          <img src={dashboard_popup_teacher_profile_details_icon} alt="" />
        </div>
        <h2>{props.subject_title}</h2>
      </div>
      <div className="dashboard-popup-teacher-profile-details-form">
        <div className="Subjects-you-teach">
          {/* isTeacher condition removed to show input field for both teacher and students as both can edit subjects now */}
          <input
            spellCheck
            type="text"
            name="subject_names"
            value={subsinput}
            style={
              formErrors.subject_names ? { border: "1px solid red" } : null
            }
            placeholder="E.g. Math, science, geography"
            onKeyPress={handleInputKeyPress}
            onChange={handleInputChange}
          />
          <button
                                        type="button"
                                        className="add_subject_feild_btn flex items-center justify-center gap-1"
                                        onClick={handleAddsubs}
                                        disabled={
                                          subsinput.trim() === "" ||
                                          subsinput === null ||
                                          subsinput === undefined
                                        }
                                        style={{
                                          backgroundColor:
                                            (subsinput.trim() === "" ||
                                              subsinput === null ||
                                              subsinput === undefined) &&
                                            "#CCCCCC",
                                        }}
                                      >
                                        Add <PlusIcon w = {12} h = {12} />
                                      </button>
        </div>
        <div className="Subjects-you-teach-feilds-folder">
          {subjects.map((subject, index) => (
            <div key={index} className="Subjects-you-teach-feilds">
              <p>{subject}</p>
              <a
                className="subject-delete-btn"
                onClick={() => removeSubject(subject)}
              >
                <i className="fa-solid fa-xmark"></i>
              </a>
            </div>
          ))}
        </div>
        <div className="Subjects-you-teach-suggestions-container">
          {
            (Object.values(Addtosubjects).filter(
              (valsubject) =>
                valsubject !== "" &&
                !subjects.some(
                  (subject) =>
                    subject.trim().toLowerCase() ===
                    valsubject.trim().toLowerCase(),
                ),
            ).length > 0 ? (
              <p className="Subjects-you-teach-suggestions-title">
                Suggestions
              </p>
            ) : null)}

          <div className="Subjects-you-teach-suggestions-folder">
            {
            // !isSuggestionsLoading ? (
            //   <div className="relative">

            //   <LoaderComponent />
            //   </div>
            // ) : (
              Addtosubjects &&
              Object.values(Addtosubjects)
                .filter(
                  (valsubject) =>
                    valsubject !== "" &&
                    !subjects.some(
                      (subject) =>
                        subject.trim().toLowerCase() ===
                        valsubject.trim().toLowerCase(),
                    ),
                )
                .map((valsubject, index) => (
                  <a key={index} onClick={() => addSuggestion(valsubject)}>
                    {valsubject}
                  </a>
                ))
            // )
            }
          </div>
        </div>
        <br />
        <p className="errorState">{formErrors.subject_names}</p>
      </div>

      <div className="modal-content-btn">
        <button onClick={onSubjectSubmit} className="submin-btn !w-fit">
          Submit
        </button>
      </div>
    </Modal>
  );
}

export default EditSubject;